import React from "react";
import { Link } from "react-router-dom";

export default function LegalPage() {
  return (
    <section>
      <aside aria-label="Related articles" className="py-8 lg:py-24 bg-gray-50 dark:bg-gray-800">
        <div className="px-4 mx-auto max-w-screen-xl">
          <h2 className="mb-8 text-4xl font-bold text-gray-900 dark:text-white text-center">Legal</h2>
          <div className="flex items-center justify-center">
            <article className="max-w-xs">
              <Link to="/privacy-policy">
                <img
                  src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/article/blog-1.png"
                  className="mb-5 rounded-lg"
                  alt="1"
                />
              </Link>
              <h2 className="mb-2 text-xl font-bold leading-tight text-gray-900 dark:text-white">
                <Link to="/privacy-policy">Our Privacy Policy</Link>
              </h2>
              <p className="mb-4 font-light text-gray-500 dark:text-gray-400">
                Over the past year, Volosoft has undergone many changes! After months of preparation.
              </p>
              <Link
                to="/privacy-policy"
                className="inline-flex items-center font-medium underline underline-offset-4 text-primary-600 dark:text-primary-500 hover:no-underline"
              >
                Read in 2 minutes
              </Link>
            </article>
            <article className="max-w-xs">
              <Link to="/terms-of-use">
                <img
                  src="https://flowbite.s3.amazonaws.com/blocks/marketing-ui/article/blog-2.png"
                  className="mb-5 rounded-lg"
                  alt="2"
                />
              </Link>
              <h2 className="mb-2 text-xl font-bold leading-tight text-gray-900 dark:text-white">
                <Link to="/terms-of-use">Our Terms of Use</Link>
              </h2>
              <p className="mb-4 font-light text-gray-500 dark:text-gray-400">
                Over the past year, Volosoft has undergone many changes! After months of preparation.
              </p>
              <Link
                to="/terms-of-use"
                className="inline-flex items-center font-medium underline underline-offset-4 text-primary-600 dark:text-primary-500 hover:no-underline"
              >
                Read in 12 minutes
              </Link>
            </article>
          </div>
        </div>
      </aside>
    </section>
  );
}
